'use strict';

const getBodyScrollTop = () => {
  const el = document.scrollingElement || document.documentElement;
  return el.scrollTop;
};

const scrollToTarget = (targetElement, heightOffset) => {
  const { browser } = window.TrackingHub ? window.TrackingHub.user : {};
  const rect = targetElement.getBoundingClientRect();
  const top = Math.ceil(rect.top + getBodyScrollTop()) - heightOffset;

  if (browser && /Chrome|Firefox/i.test(browser)) {
    window.scrollTo({
      top,
      behavior: 'smooth',
    });
  } else {
    window.scrollTo(0, top);
  }
};

const bindTargetNavigation = (anchorElement, beforeScroll) => {
  if (!anchorElement) {
    return;
  }

  const href = anchorElement.getAttribute('href');
  let targetElement;
  if (!href || !(targetElement = document.getElementById(href.slice(1)))) {
    return;
  }

  anchorElement.addEventListener('click', e => {
    e.preventDefault();

    const promise = new Promise(resolve => {
      if (beforeScroll != null) {
        beforeScroll({ resolve });
      } else {
        resolve(0);
      }
    });

    return promise.then((heightOffset = 0) => {
      scrollToTarget(targetElement, heightOffset);
    });
  });
};

module.exports = { bindTargetNavigation, scrollToTarget };
